import { useState, useEffect } from "react";
import { FaChevronUp } from "react-icons/fa";
import "./App.css";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import { Routes, Route } from "react-router-dom";
import SearchResults from "./pages/SearchResults";
import VehiclePage from "./pages/VehiclePage";
import Policy from "./pages/PrivacyPolicy";
import Locations from "./pages/Locations";
import LocationDetails from "./pages/LocationDetails";
import ContactUs from "./pages/ContactUs";
import Offers from "./pages/Offers";
import ReservationCheck from "./pages/ReservationCheck";
import ReservationDetails from "./pages/ReservationDetails";
import Checkout from "./pages/Checkout";
import Confirmation from "./pages/Confirmation";
import RentalPolicy from "./pages/RentalPolicy";
import OfferDetails from "./pages/OfferDetails";


function App() {
  const [showTopBtn, setShowTopBtn] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowTopBtn(true);
      } else {
        setShowTopBtn(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="flex flex-col min-h-screen relative">
      <div className="fixed top-0 w-full z-50">
        <Navbar />
      </div>

      {/* Main content */}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/results" element={<SearchResults />} />
          <Route path="/vehicles" element={<VehiclePage />} />
          <Route path="/policy" element={<Policy />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/location-details" element={<LocationDetails />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/bookings" element={<ReservationCheck />} />
          <Route path="/reservation-details" element={<ReservationDetails />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/rental-policy" element={<RentalPolicy />} />
          <Route path="/offer-details/:slug" element={<OfferDetails />} />
        </Routes>
      </main>

      <Footer />

      {/* Back to Top Button */}
      {showTopBtn && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 bg-[#ca8032] text-white p-3 rounded shadow-lg hover:bg-[#a06427] transition z-50"
        >
          <FaChevronUp />
        </button>
      )}
    </div>
  );
}

export default App;
